import styled from "styled-components";

export const Container = styled.section`
    width: 100%;
`;

export const Wrapper = styled.div`
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    min-height: calc(100vh - 90px);

    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: center;
    gap: 6rem;

    padding: 7rem 2rem 5rem;

    @media (max-width: 1200px) {
        gap: 4rem;
    }

    @media (max-width: 992px) {
        grid-template-columns: 1fr;
        text-align: center;
        gap: 3.5rem;
        padding: 6rem 2rem;
    }

    @media (max-width: 576px) {
        padding: 5rem 1.5rem;
    }
`;

export const LeftContent = styled.div`
    max-width: 620px;
    
    display: flex;
    flex-direction: column;
    
    justify-content: center;
    align-items: flex-start;

    @media (max-width: 992px) {
        align-items: center;

        margin: 0 auto;
    }
`;

export const RightContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;

    transform: translateY(-20px);

    @media (max-width: 992px) {
        transform: none;
    }
`;

export const Badge = styled.span`
    margin-bottom: 24px;
`;

export const Title = styled.h1`
    margin-bottom: 24px;
`;

export const Description = styled.p`
    max-width: 560px;

    margin-bottom: 40px;

    line-height: 1.8;
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 1rem;
    margin-bottom: 2.5rem;
    flex-wrap: wrap;

    @media (max-width: 576px) {
        width: 100%;
        flex-direction: column;
    }
`;

export const PrimaryButton = styled.a`
    display: inline-flex;
    align-items: center;
    justify-content: center;

    padding: 1rem 2rem;

    border-radius: ${({ theme }) => theme.borderRadius.md};

    background: ${({ theme }) => theme.colors.primary};

    color: ${({ theme }) => theme.colors.background};

    text-decoration: none;

    font-weight: 600;

    gap: .6rem;

    transition: 
        transform .3s ease,
        box-shadow .3s ease,
        background .3s ease;

    box-shadow: 0 12px 30px rgba(127, 191, 208, .25);

    &:hover {
        transform: translateY(-3px);

        box-shadow: 0 18px 40px rgba(127, 191, 208, .35);
    }

    svg{
        flex-shrink: 0;
    }
`;

export const SecondaryButton = styled.a`
    display: inline-flex;
    align-items: center;
    justify-content: center;

    padding: 1rem 2rem;

    gap: .6rem;
    
    svg{
        flex-shrink: 0;
    }

    border-radius: ${({ theme }) => theme.borderRadius.md};

    background: transparent;

    border: 1px solid rgba(255, 255, 255, .12);

    color: ${({ theme }) => theme.colors.white};

    text-decoration: none;

    font-weight: 600;

    transition: .3s ease;

    &:hover {
        background: rgba(255, 255, 255, .05);

        border-color: ${({ theme }) => theme.colors.primary};

        color: ${({ theme }) => theme.colors.primary};
    }
`;

export const TechStack = styled.div`
    display: flex;
    gap: .75rem;
    flex-wrap: wrap;

    @media (max-width: 992px) {
        justify-content: center;
    }
`;

export const TechChip = styled.div``;

export const Dashboard = styled.div`
    width: 100%;
    max-width: 520px;
    aspect-ratio: 16 / 11;

    border-radius: 24px;

    display: flex;
    justify-content: center;
    align-items: center;
`;